<template>
  <div>
    <h3 class="stitle mb50">체험자 정보</h3>
    <dl class="mb30">
      <dt class="stitle2 tleft">단체 정보</dt>
      <dd class="colorBox">
        <ul class="inputBox">
          <li class="radiobox">
            <label>단체구분</label>
            <span>
              <input type="radio" name="orgType" id="orgTypeSel1" value="01" v-model="orgInfo.orgType" />
              <label for="orgTypeSel1"><span>학교/유치원</span></label>
              <input type="radio" name="orgType" id="orgTypeSel2" value="09" v-model="orgInfo.orgType" />
              <label for="orgTypeSel2"><span>기타</span></label>
            </span>
          </li>
          <li>
            <label>
              단체명
              <sup class="red">*</sup>
            </label>
            <span>
              <vue-simple-suggest
                v-model="chosen"
                display-attribute="orgName"
                value-attribute="hpOrgInfoId"
                :list="getOrgSuggestionList"
                :debounce="200"
                @select="onSuggestSelect"
              >
                <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
                  <div class="orgInfo-suggestion">
                    <div class="orgName">{{ scope.suggestion.orgName }}</div>
                    <div class="orgAddress">{{ scope.suggestion.basicAddress }}</div>
                  </div>
                </div>
              </vue-simple-suggest>
            </span>
          </li>
          <li>
            <label>
              주소
              <sup class="red">*</sup>
            </label>
            <span>
              <input type="text" name="basicAddress" v-model="orgInfo.basicAddress" autocomplete="off" />
              <br />
              <input type="text" name="etcAddress" v-model="orgInfo.etcAddress" autocomplete="off" />
            </span>
          </li>
          <li>
            <label>
              학년
              <sup class="red">*</sup>
            </label>
            <span>
              <div v-for="(value, name) in gradeList" :key="name" class="grade-wrap">
                <div>{{ name }}</div>
                <div class="grade-check-wrap">
                  <span class="checkbox" v-for="grade in value" :key="grade.cd">
                    <input type="checkbox" :value="grade.cd" :id="'chk_' + grade.cd" v-model="orgInfo.grades" />
                    <label :for="'chk_' + grade.cd">{{ grade.cdNm }}</label>
                  </span>
                </div>
              </div>
            </span>
          </li>
        </ul>
      </dd>
    </dl>
    <div v-if="(experPcntList.find((e) => e.discRate !== 0) !== undefined && experPcntList.length !== 1) || productItem.pdDiv !== '09'">
      면제 및 할인 대상자가 있을 경우
      <br />
      아래양식을 작성하여 체험당일 지참해주시기 바랍니다.
      <br />
      <a href="/file/koreajobworldHM_New.hwp" target="_blank">
        <span>할인/면제대상 확인서</span>
        &nbsp;
        <span style="font-weight: 500">다운로드</span>
      </a>
    </div>
    <dl>
      <dt class="stitle2 tleft">체험자 인원 정보</dt>
      <dd class="colorBox">
        <label>복지할인 대상</label>
        <ul class="">
          <li>
            <ul class="pers_list" style="background-color: white">
              <li v-for="experPcnt in experPcntList" :key="experPcnt.key">
                <span>{{ experPcnt.note }} - {{ experPcnt.discRate }}%</span>
                <div v-if="experPcnt.pesnDivCd === '01'">{{ experPcnt.pcnt }} 명</div>
                <div v-else class="flex-box">
                  <count-button
                    title="인원"
                    :value="experPcnt.pcnt"
                    :checkValue="10"
                    :valid="grpSalePcntValid"
                    :onChange="onChangeGrpSalePcntInfo"
                    :target="experPcnt"
                  />
                  명
                </div>
              </li>
              <li>
                <span>총 인원</span>
                <div>{{ totExperPcnt }} 명</div>
              </li>
            </ul>
          </li>
        </ul>
      </dd>
    </dl>
    <dl v-for="(info, index) in leaderPcntList" :key="info.key">
      <dt class="stitle2 tleft">
        보호자/인솔자 {{ index + 1 }} 정보
        <div class="tit_btnbox">
          <a v-if="index === 0" class="" @click="() => onInputMyInfo(info)">내정보 불러오기</a>
          <a class="btn_color" @click="() => openFamilyInfo(1, info)">가족정보 불러오기</a>
        </div>
      </dt>
      <dd class="colorBox">
        <ul class="inputBox">
          <li>
            <label :for="info.key + '_name'">이름</label>
            <span>
              <input type="text" :id="info.key + '_name'" name="leaderNm" :value="info.leaderNm" @input="onPcntChange($event, info)" />
            </span>
          </li>
          <li>
            <label :for="info.key + '_tel'">휴대폰</label>
            <span>
              <input type="tel" :id="info.key + '_tel'" name="phoneNo" :value="info.phoneNo" @input="onPcntChange($event, info)" />
            </span>
          </li>
          <li>
            <label :for="info.key + '_email'">이메일</label>
            <span>
              <input type="text" :id="info.key + '_email'" name="email" :value="info.email" @input="onPcntChange($event, info)" />
            </span>
          </li>
          <li v-if="info.pesnPriceList">
            <label :for="info.key + '_pesnDivCd'">복지할인</label>
            <span>
              <select name="pesnDivCd" :id="info.key + '_pesnDivCd'" :value="info.pesnDivCd" @input="onPcntPesnDivChange($event, info)">
                <option v-for="pp in info.pesnPriceList" :key="pp.pesnDivCd" :value="pp.pesnDivCd">{{ pp.note }} ({{ pp.discRate }}%)</option>
              </select>
            </span>
          </li>
        </ul>
      </dd>
    </dl>
    <div v-if="productItem.mrktnPdNo == '100035'" style="padding-top: 15px" data-target="#mktAgree">
      <mkt-agree-popup v-model="mktAgree" />
    </div>      
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" :title="modal.title">
      <!-- default 슬롯 콘텐츠 -->
      <family-list :value="modal.familyList" :select="selectFamilyInfo" />
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import moment from 'moment';
import { getOrgInfos, getFamilyList } from '@/api/api_reserve';
import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS
import { mapActions, mapGetters, mapState } from 'vuex';
import CountButton from '@/components/common/CountButton.vue';
import FamilyList from '@/components/product/detail/FamilyList.vue';
import Modal from '@/components/common/Modal.vue';
import MktAgreePopup from '@/components/popup/MktAgreePopup.vue';

export default {
  components: {
    VueSimpleSuggest,
    CountButton,
    Modal,
    FamilyList,
    MktAgreePopup
  },
  data: function () {
    return {
      chosen: '',
      orgNm: '',
      modal: {
        open: false,
        title: '가족 정보 선택',
        familyList: [],
        target: '',
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
      reserve: (state) => state.reserve,
      productItem: (state) => state.reserve.productItem,
      orgInfo: (state) => state.reserve.orgInfo,
      experPcntList: (state) => state.reserve.experPcntList,
      leaderPcntList: (state) => state.reserve.leaderPcntList,
      userInfo: (state) => state.ui,
      totExperPcnt() {
        return this.experPcntList?.reduce((a, e) => a + e.pcnt, 0) || 0;
      },
    }),
    ...mapGetters('reserve', ['mstrPdList']),
    chkChildAge() {
      return Boolean(this.mstrPdList.find((e) => e.pdDiv === '01'));
    },
    gradeList() {
      if (!this.productItem.gradeList) return {};
      const orgGradeList = this.productItem.gradeList;
      const gubun = {};
      orgGradeList.forEach((e) => {
        if (gubun[e.schGubun]) {
          gubun[e.schGubun].push(e);
        } else {
          gubun[e.schGubun] = [e];
        }
      });
      return gubun;
    },
    normalPcnt() {
      const normal = this.experPcntList.find((e) => e.pesnDivCd === '01');
      return normal;
    },

    mktAgree: {
      get() {
        return this.$store.state.reserve.mktAgree;
      },
      set(value) {
        this.editReserveInfo({ mktAgree: value });
      },
    },       
  },
  watch: {
    chosen(to) {
      this.changeOrgInfo({ orgName: to });
    },
    orgInfo: {
      deep: true,
      handler(to) {
        sessionStorage.setItem('prevGroupInfo', JSON.stringify(to));
      },
    },
  },
  methods: {
    ...mapActions('reserve', ['changeGrpSalePcntInfo', 'changeOrgInfo', 'changePcntInfo', 'changePcntInfos', 'calcPrice','editReserveInfo']),
    getOrgSuggestionList(inputValue) {
      return getOrgInfos(inputValue).then((res) => {
        if (res.success) {
          return res.response.orgList;
        } else {
          return [];
        }
      });
    },
    onSuggestSelect(suggest) {
      this.changeOrgInfo(suggest);
    },
    grpSalePcntValid(to, from) {
      const gap = to - from;
      if (this.normalPcnt?.pcnt >= gap) {
        return false;
      } else {
        return true;
      }
    },
    onChangeGrpSalePcntInfo(value, target) {
      this.changeGrpSalePcntInfo({ value, target });
      this.calcPrice(this.groupPersDiv); //01
    },
    onPcntPesnDivChange(event, target) {
      this.changePcntInfo({ event, target });
      this.calcPrice(this.groupPersDiv); //01
    },
    onPcntChange(event, target) {
      this.changePcntInfo({ event, target });
    },
    onInputMyInfo(target) {
      const datas = {
        leaderNm: this.userInfo.userName,
        phoneNo: this.userInfo.userMobileNum,
        email: this.userInfo.userEmail,
      };
      this.changePcntInfos({ target, datas });
    },
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    selectFamilyInfo(info) {
      this.closeModal();
      const target = this.modal.target;
      if (target) {
        let incluBirthMonDate =
          (info.incluBirthMonDate || '').length === 8 ? moment(info.incluBirthMonDate, 'YYYYMMDD').format('YYYY-MM-DD') : target.incluBirthMonDate;
        let datas = {};
        if (target.reciDivCd === '20') {
          datas = {
            incluNm: info.incluNm || target.incluNm,
            incluBirthMonDate: incluBirthMonDate,
            incluGrade: info.incluGrade || target.incluGrade,
            incluClass: info.incluClass || target.incluClass,
            incluClsNo: info.incluClsNo || target.incluClsNo,
            incluUserId: info.incluUserId || target.incluUserId,
            email: info.email || target.email,
          };
        } else if (target.reciDivCd === '10') {
          datas = {
            leaderNm: info.incluNm || target.leaderNm,
            phoneNo: info.phoneNo || target.phoneNo,
            email: info.email || target.email,
          };
        }

        this.changePcntInfos({ target, datas });
      }
    },
    async openFamilyInfo(linkCd, target) {
      this.openModal();
      this.getUserFamilyList(linkCd);
      this.modal.target = target;
    },
    async getUserFamilyList(linkCd) {
      const data = await getFamilyList(linkCd);
      if (data.success) {
        this.modal.familyList = data.response.familyList;
      }
    },
    
  },
  mounted() {
    const prevGroupInfo = sessionStorage.getItem('prevGroupInfo');
    if (prevGroupInfo) {
      const groupInfo = JSON.parse(prevGroupInfo);
      const gradeList = this.productItem?.gradeList;

      //gradeList가 늦게 불러와지는 경우는 처리 안함(필요시 gradeList watch나 computed에서 처리)
      if (groupInfo && groupInfo.basicAddress && !isEmpty(gradeList)) {
        this.chosen = groupInfo.orgName || '';
        if (!isEmpty(groupInfo.grades)) {
          groupInfo.grades = groupInfo.grades.filter((e) => gradeList.findIndex((g) => g.cd === e) > -1);
        }
        this.changeOrgInfo(groupInfo);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.orgInfo-suggestion {
  & > .orgName {
    font-size: 16px;
  }
  & > .orgAddress {
    color: #999;
    font-size: 14px;
  }
}
.grade-wrap {
  display: flex;
  padding: 3px 0;
  & div {
    padding-right: 5px;
  }
}
.grade-check-wrap {
  display: flex;
  & > span {
    padding-right: 5px;
  }
}
.flex-box {
  display: flex;
}
</style>
